import Constants from '../utils/consts';
import Cookies from 'universal-cookie';

var db = new Cookies().get('db', { path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');

export default async function getAllDocuments(uname, token, corso) {
    return new Promise(function (resolve, reject) {

        var options = {
            'method': 'POST',
            'hostname': Constants.ipAddress,
            'path': Constants.apisFolder + 'getAllDocuments.php',
            'headers': {
                'Content-Type': 'application/x-www-form-urlencoded',
                'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
            },
            'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
            var chunks = [];

            res.on("data", function (chunk) {
                chunks.push(chunk);
            });

            res.on("end", function (chunk) {
                var body = Buffer.concat(chunks);
                try {
                    var resp = JSON.parse(body.toString());
                    resolve(resp);
                } catch (e) {
                    resolve(undefined);
                }
            });

            res.on("error", function (error) {
                console.error(error);
            });
        });

        var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'db_name': db,
            'id_corso': corso
        });

        req.write(postData);

        req.end();


    });
}